/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Free_TrialInputs */

const en_app_footer_free_trial = /** @type {(inputs: App_Footer_Free_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Trial`)
};

const es_app_footer_free_trial = /** @type {(inputs: App_Footer_Free_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba gratuita`)
};

/**
* | output |
* | --- |
* | "Free Trial" |
*
* @param {App_Footer_Free_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_free_trial = /** @type {((inputs?: App_Footer_Free_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Free_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_free_trial(inputs)
	return en_app_footer_free_trial(inputs)
});